import dayjs from 'dayjs';

const utilities = {
	convertMsToHM(milliseconds) {
		let seconds = Math.floor(milliseconds / 1000),
			minutes = Math.floor(seconds / 60),
			hours = Math.floor(minutes / 60);
		seconds %= 60;
		// if seconds are greater than 30, round minutes up (optional
		// minutes = seconds >= 30 ? minutes + 1 : minutes;
		minutes %= 60;
		// If you don't want to roll hours over, e.g. 24 to 0
		// comment (or remove) the line below
		// commenting next line gets you `24:00:00` instead of `00:00:00
		// or `36:15:31` instead of `12:15:31`, etc
		// hours = hours % 24;

		return { hours, minutes, seconds };
	},

	getSingleLibraryNameForDocumentTitle: (title) => {
		if (utilities.isValidDocumentationDocName(title)) return title.substring(0, 2);

		if (utilities.isValidM3DocName(title)) return title.substring(0, 3);

		return null;
	},

	isValidDocumentationDocName: (docName) => Boolean(docName && docName.match(/^[A-Z]{2}[0-9]{5}$/i)),

	isValidM3DocName: (docName) => Boolean(docName && docName.match(/^[0-9]{1}([0-9]|[A-Z]){1}[0-9]{1}[A-Z]{2}[0-9]{6}([EM]{1})*$/i)),

	multiCriteriaSort: (criteria, order) => {
		if (typeof criteria === 'string') return utilities.multiCriteriaSort([criteria], order);

		return (a, b) => {
			let criteriaArr = criteria[0].split('.'),
				aVal = criteriaArr.reduce((accum, elem) => accum[elem], a),
				bVal = criteriaArr.reduce((accum, elem) => accum[elem], b),
				desc = (order === -1 ? -1 : 1);

			if (dayjs.isDayjs(aVal)) {
				if (aVal.isBefore(bVal)) return -desc;
				if (aVal.isAfter(bVal)) return desc;
			} else {
				aVal = aVal.toLowerCase();
				bVal = bVal.toLowerCase();
				if (aVal < bVal) return -desc;
				if (aVal > bVal) return desc;
			}

			if (criteria.length > 1) {
				return utilities.multiCriteriaSort(criteria.slice(1), order)(a, b);
			}
			return 0;
		};
	},

	size: (fileSize) => {
		// https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
		const k = 1024,
			dm = 2,
			sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			i = Math.floor(Math.log(fileSize) / Math.log(k));

		return `${parseFloat(fileSize / (k ** i)).toFixed(dm)} ${sizes[i]}`;
	},

	downloadSharepointFile(url, fallbackFileName = 'download') {
		try {
			let fileName = fallbackFileName;
			const urlParts = url.split('?')[0].split('/'),
				lastPart = urlParts[urlParts.length - 1],
				proxyUrl = `/products-homepage/api/proxy-download?url=${encodeURIComponent(url)}`,
				link = document.createElement('a');
			if (lastPart) {
				fileName = decodeURIComponent(lastPart);
			}

			link.href = proxyUrl;
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();

			setTimeout(() => {
				link.parentNode.removeChild(link);
			}, 100);
		} catch (error) {
			console.error('[PRODUCTS] Error downloading file:', error);
			window.open(url, '_blank').focus();
		}
	},
};

export { utilities };
